var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentorships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n\t.st1{fill:#FFE7E5;}\n\t.st2{fill:#E9EBEF;}\n\t.st3{fill:#FF877F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,47.3c-12.2,0-22.1-9.9-22.1-22.1C2.9,13,12.9,3.1,25,3.1S47.2,13,47.2,25.2c0,2.1-0.3,4.2-0.9,6.2 c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2-0.1-0.3-0.3-0.3-0.5c0.6-1.9,0.9-4,0.9-6c0-11.8-9.6-21.3-21.3-21.3S3.7,13.5,3.7,25.2 C3.7,37,13.3,46.5,25,46.5c0.2,0,0.4,0.2,0.4,0.4C25.4,47.2,25.3,47.3,25,47.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,50.2c-13.8,0-25-11.2-25-25c0-2.4,0.3-4.8,1-7c0.1-0.2,0.3-0.4,0.6-0.3c0.3,0,0.4,0.3,0.4,0.5 c-0.6,2.2-1,4.5-1,6.8c0,13.3,10.8,24.1,24,24.1s24.1-10.8,24.1-24.1S38.3,1.2,25,1.2c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4 c13.8,0,25,11.2,25,25S38.8,50.2,25,50.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,18.9c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4C20.3,17.4,18.7,18.9,16.9,18.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 18.9,
    className: "st2",
    width: 14.9,
    height: 12.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "14.9,37.9 14.3,30.4 12,30.4 13.6,21.6 19.7,21.6 25.7,24.6 25.7,27.2 20.2,25.8 18.8,37.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,19.6c2.2,0,4.1-1.8,4.1-4.1s-1.8-4.1-4.1-4.1c-2.2,0-4.1,1.8-4.1,4.1S14.6,19.6,16.9,19.6z M16.9,12.8 c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7S15.4,12.8,16.9,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,18.2H23.6c-0.7,0-1.4,0.6-1.4,1.4v2.6l-2.1-1.1c-0.2-0.1-0.4-0.1-0.6-0.1h-5.4c-0.7,0-1.2,0.5-1.3,1.1 l-1.4,7.5c-0.1,0.4,0,0.8,0.3,1.1c0.3,0.3,0.6,0.5,1,0.5h0.9l0.5,6.2c0.1,0.7,0.6,1.2,1.4,1.2h2.7c0.7,0,1.3-0.5,1.3-1.2l1.2-10.7 l1.5,0.4v3.3c0,0.7,0.6,1.4,1.4,1.4h5.6l-3.5,5.8c-0.2,0.3-0.1,0.7,0.2,0.9c0.3,0.2,0.7,0.1,0.9-0.2l2.8-4.7v4.3 c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-4.3l2.8,4.7c0.1,0.2,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3-0.1c0.3-0.2,0.4-0.6,0.2-0.9 l-3.5-5.8h5.6c0.7,0,1.4-0.6,1.4-1.4V19.6C38.6,18.8,37.9,18.2,37.2,18.2z M19.6,25l-1.4,12.2h-2.7l-0.6-7.5h-2.1l1.4-7.5h2v4.1 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-4.1h2L25,25v1.4L19.6,25z M37.2,30.4H23.6v-3l1,0.3c0.1,0,0.2,0,0.3,0 c0.3,0,0.6-0.1,0.8-0.3c0.3-0.3,0.5-0.7,0.5-1.1v-1l8.3-2.4c0.4-0.1,0.6-0.5,0.5-0.8c-0.1-0.4-0.5-0.6-0.8-0.5L25.9,24 c-0.1-0.1-0.2-0.2-0.3-0.2l-2-1v-3.2h13.6V30.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorships);
export default __webpack_public_path__ + "static/media/mentorships.8a4834857b71d1f31a4a7d679bd9e1f8.svg";
export { ForwardRef as ReactComponent };